import { render, staticRenderFns } from "./CheckoutBox.vue?vue&type=template&id=3989dd76"
import script from "./CheckoutBox.vue?vue&type=script&lang=js"
export * from "./CheckoutBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports